import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { Mail, CheckCircle, XCircle } from 'lucide-react';
import { supabase } from '../utils/supabase';

const VerifyEmail = () => {
  const navigate = useNavigate();
  const [verifying, setVerifying] = useState(true);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    const handleEmailVerification = async () => {
      try {
        // Get the error and refresh token from URL
        const params = new URLSearchParams(window.location.hash.substring(1));
        const errorDescription = params.get('error_description');
        const refreshToken = params.get('refresh_token');

        if (errorDescription) {
          throw new Error(errorDescription);
        }

        if (!refreshToken) {
          throw new Error('No refresh token found');
        }

        // Exchange refresh token for session
        const { error } = await supabase.auth.refreshSession({
          refresh_token: refreshToken
        });

        if (error) throw error;

        // Verification successful
        setVerifying(false);
        setTimeout(() => {
          navigate('/dashboard');
        }, 2000);
      } catch (error) {
        setError(error instanceof Error ? error.message : 'Verification failed');
        setVerifying(false);
      }
    };

    handleEmailVerification();
  }, [navigate]);

  return (
    <div className="container mx-auto px-4">
      <div className="min-h-[calc(100vh-200px)] flex items-center justify-center py-12">
        <div className="max-w-md w-full space-y-8 bg-white p-8 rounded-xl shadow-lg text-center">
          {verifying ? (
            <>
              <div className="flex justify-center">
                <Mail className="h-12 w-12 text-purple-600 animate-pulse" />
              </div>
              <h2 className="text-3xl font-bold text-gray-900">Verifying your email</h2>
              <p className="text-gray-600">Please wait while we verify your email address...</p>
            </>
          ) : error ? (
            <>
              <div className="flex justify-center">
                <XCircle className="h-12 w-12 text-red-600" />
              </div>
              <h2 className="text-3xl font-bold text-gray-900">Verification failed</h2>
              <p className="text-red-600">{error}</p>
              <button
                onClick={() => navigate('/login')}
                className="mt-4 text-purple-600 hover:text-purple-700 font-medium"
              >
                Return to login
              </button>
            </>
          ) : (
            <>
              <div className="flex justify-center">
                <CheckCircle className="h-12 w-12 text-green-600" />
              </div>
              <h2 className="text-3xl font-bold text-gray-900">Email verified!</h2>
              <p className="text-gray-600">
                Your email has been verified successfully. Redirecting you to the dashboard...
              </p>
            </>
          )}
        </div>
      </div>
    </div>
  );
};

export default VerifyEmail;